export default "__VITE_ASSET__D4_KgYCR__"